import { Card, Collapse } from '@mui/material';

import {
  Typography,
  CardContent,
  CardHeader,
  DocumentScannerOutlinedIcon,
  IconAvatar,
} from '@occc/ui-design-system';
import { TextField, Switches } from '@occc-app/design-system';
import { MarketingContentFormValuesPaths } from '@occc-app/offerHelpers/DesignForm/types';

import { CustomDataFormValues, CustomDataFormValuesYup } from './types';

type CustomDataProps = {
  // Games still use Yup based validation, so we need to keep
  // CustomDataFormValuesYup this type here.
  values?: CustomDataFormValues | CustomDataFormValuesYup;
  subtitle?: string;
  label?: string;
};

export const CustomData = ({
  values,
  label = 'Offer Custom Data',
  subtitle = 'Use custom data to implement enhanced marketing experiences in your app and other channels',
}: CustomDataProps) => {
  return (
    <Card elevation={0} sx={{ mb: 0 }}>
      <CardHeader
        title={<Typography variant='subtitle1'>{label}</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            {subtitle}
          </Typography>
        }
        action={
          <Switches
            name={'customData.isEnabled' satisfies MarketingContentFormValuesPaths}
            data={{}}
          />
        }
        avatar={<IconAvatar Icon={DocumentScannerOutlinedIcon} />}
        sx={{ py: 2, px: 3 }}
      />
      <Collapse in={values?.isEnabled} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <TextField
            placeholder='Enter custom data here'
            multiline
            rows={6}
            name={'customData.data' satisfies MarketingContentFormValuesPaths}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
};
